import app from './app';
import color from './color';
import user from './user';

export default {
  ...app,
  ...color,
  ...user,
};



// WEBPACK FOOTER //
// ./scripts/reducers/index.js